import store from '@/store';
import { isEmpty } from '@/common/utils/Util';

export const tokenRenewCheck = async (to, next) => {
  if (to.path !== '/main' && to.path !== '/intro') return true; // 260909 /intro 가 메인 // 메인 페이지가 아닌 경우 토큰 체크를 하지 않음.
  const ttl = store.getters['user/getTTL'];
  if (isEmpty(ttl)) return true;
  const currentDate = new Date().getTime();
  const sevenDaysInMillis = 7 * 24 * 60 * 60 * 1000;
  const endDaysInMillis = 20 * 24 * 60 * 60 * 1000;
  const ttlWithSevenDays = ttl + sevenDaysInMillis;
  const ttlWithEndDays = ttl + endDaysInMillis;

  if (currentDate >= ttlWithEndDays) {
    await store.dispatch('user/signOut');
    // 260521 호크룩스: history stack에 /signin push 방지 → replace
    next({ path: '/signin', replace: true });
    return false;
  }
  if (currentDate >= ttlWithSevenDays) {
    await store.dispatch('user/renewAccessToken');
  }
  return true;
};
